module.exports = __webpack_public_path__ + "static/img/service_01.a0801c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/service_01.png
// module id = y+wV
// module chunks = 0